import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { sentenceCase } from '../../scripts/string-manipulators';
import IconArrowDown from '../../vectors/icon-arrow-down';
import classes from '../../styles/portfolio.module.css';
import CC from '../../scripts/combine-classes';

type SectionProps = {
  children: ReactNode,
  collective: string,
  extraClasses?: string,
  id?: string | null,
  title: string,
}

const Section = ({
  children,
  collective,
  extraClasses = '',
  id,
  title,
}: SectionProps) => {
  return (
    <section className={CC(classes.container, extraClasses)}>
      <header className={classes.header}>
        {id && (
          <Link
            to={'/damien-watson/projects'}
          >
            <IconArrowDown />
          </Link>
        )}
        <h1 className={classes.h1}>{id ? `${title}: ${sentenceCase(id)}` : `${collective}`}</h1>
      </header>
      {children}
    </section>
  );
};

export default Section;
